jQuery('.block--item-block-podcast').each(function() {
  let audio = jQuery(this).find('audio');
  let timeline = jQuery(this).find('.piste');
  let title = jQuery(this).find('.expert-title');

  let dataLayerSent = false;

  // Lancer ou couper le player
  const playBtn = jQuery(this).find('.btn-play');
  playBtn.click(function() {
    if(audio[0].paused) {
      jQuery(this).removeClass('play');
      jQuery(this).addClass('pause');
      audio.trigger("play");

      if (dataLayerSent === false) {
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'av.play',
            av_content : title.text().trim()
          });
          dataLayerSent = true;
        });
      }

    } else {
      jQuery(this).removeClass('pause');
      jQuery(this).addClass('play');
      audio.trigger("pause");
    }
  });

  // Au clic sur la timeline on va au temps correspondant
  timeline.on('click', function(e) {
    var audioDuration = audio[0].duration;
    var timelineWidth = jQuery(this).innerWidth();
    const timeToSeek = e.offsetX / parseInt(timelineWidth) * audioDuration;
    audio[0].currentTime = timeToSeek;
    jQuery(this).parent().find('.timer').children('.current').html(convertTimer(timeToSeek));
    jQuery(this).parent().find('.piste-timer').css('width', timeToSeek / audioDuration * 100 + "%");
  });

  // On met à jour l'avancement du timer
  setInterval(() => {
    const progressBar =  jQuery(this).find('.piste-timer');
    var audioCurTime = audio[0].currentTime;
    var audioDuration = audio[0].duration;
    // On récupère la durée totale de l'audio
    if(audioDuration !== 'NaN') jQuery(this).find('.timer').children('.total').html(convertTimer(audioDuration));
    progressBar.css('width', audioCurTime / audioDuration * 100 + "%");
    jQuery(this).find('.timer').children('.current').html(convertTimer(audioCurTime));

    // Si on arrive à la fin on met en pause le lecteur
    if(audioCurTime === audioDuration) {
      jQuery(this).find('.btn-play').addClass('play');
      jQuery(this).find('.btn-play').removeClass('pause');
    }
  }, 500);
});

// Conversion du temps en string
function convertTimer(d) {
  var convertTimer = '';
  var d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  if(h !== 0) convertTimer = (h < 10) ? '0' + h + ':' : h + ':';
  convertTimer = (m < 10) ? convertTimer + '0' + m + ':' : convertTimer + m + ':';
  convertTimer = (s < 10) ? convertTimer + '0' + s : convertTimer + s;
  return convertTimer;
}

if (jQuery('.block-read-more-podcast').length) {
  jQuery(".block-read-more-podcast #read-more-podcast").click(function () {
    var dataPodcast = jQuery(this).attr("data-podcast");
    //alert(".data-"+dataVideo+" #read-more-podcast");
    var elem = jQuery(".podcast-" + dataPodcast + " #read-more-podcast").text();

    if (jQuery(".podcast-" + dataPodcast + " .more-podcast").hasClass("hide")) {
      jQuery(".podcast-" + dataPodcast + " #read-more-podcast .text-read-more").text('Voir moins');
      jQuery(".podcast-" + dataPodcast + " #text-more-podcast").slideDown();
      jQuery(".podcast-" + dataPodcast + " .more-podcast").removeClass("hide");
      jQuery(".podcast-" + dataPodcast + " .intro-podcast").addClass("open");
      jQuery(".podcast-" + dataPodcast + " .text-read-more").addClass("open");
      self.open = true;
    } else {
      jQuery(".podcast-" + dataPodcast + " #read-more-podcast .text-read-more").text('Voir plus');
      jQuery(".podcast-" + dataPodcast + " #text-more-podcast").slideUp();
      jQuery(".podcast-" + dataPodcast + " .more-podcast").addClass("hide");
      jQuery(".podcast-" + dataPodcast + " .intro-podcast").removeClass("open");
      jQuery(".podcast-" + dataPodcast + " .text-read-more").removeClass("open");
    }
  });
}
